import _get from 'lodash/get'

import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import { FAILURE_REASONS } from './constants'
import type { GetFailureReason } from './types'

const getDroneFailureReason: GetFailureReason = ({
  formValues,
  stepTransformer = (step: string) => step,
  currentStep,
}) => {
  const { getHelperPath } = generateGetFlowValueFunctions('liability_v1_getsafe_de')

  switch (currentStep) {
    case stepTransformer('drone_weight'): {
      const weight_is_too_high = _get(formValues, getHelperPath('weight_is_too_high'))
      return {
        reason: FAILURE_REASONS.DRONE_TOO_HEAVY,
        extraData: { weight_is_too_high },
      }
    }
    default: {
      break
    }
  }
}
export default getDroneFailureReason
